@if (listOfStops().length) {
  <app-accordion-group>
    @for (item of listOfStops(); track $index) {
      <app-accordion-item
        [name]="item | busStopLabel"
        [expanded]='expanded'
        [disabled]='false'>
        <div class="row">
          <div class='col-md-4'>
            <app-label label='Nazwa przystanku:'>
              {{ item?.stopName || '-' }}
            </app-label>
          </div>
          <div class='col-md-4'>
            <app-label label='Strona drogi:'>
              {{ item?.roadSide || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Lokalizacja - kilometraż:">
              {{ item?.location || '-' }}
            </app-label>
          </div>
        </div>
        <div slot="action">
          @if (showActions()) {
            <button
              (click)='onEdit.emit({ v: item, i: $index }); $event.preventDefault(); $event.stopPropagation();'
              class='btn btn-secondary icon-btn'
              title='Edytuj'
              type="button"
              [disabled]='!canEdit()'>
              <i class='fa fa-pencil-alt'></i>
            </button>
            &nbsp;
            <button
              [disabled]='!canEdit()'
              type='button'
              class='btn btn-red-secondary icon-btn' title='Usuń z listy'
              (click)='onRemove.emit($index); $event.preventDefault(); $event.stopPropagation();'>
              <i class='fa fa-trash-alt'></i>
            </button>
          }
        </div>
      </app-accordion-item>
    }
  </app-accordion-group>
}
